import {gql} from '@apollo/client';

export const GET_COMPLY_CUBE_CLIENTS = gql`
  query GetComplyCubeClients($input: GetComplyCubeClientsInput) {
    getComplyCubeClients(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithComplyCubeClients {
        data {
          _id
          id
          entityName
          type
          email
          createdAt
          updatedAt
          personDetails {
            firstName
            lastName
            dob
            nationality
          }
          user {
            id
            firstName
            lastName
            email
          }
        }
        pagination {
          total
        }
      }
    }
  }
`;

export const GET_COMPLY_CUBE_CLIENT_DETAILS = gql`
  query GetComplyCubeClientDetails($input: GetComplyCubeClientDetailsInput!) {
    getComplyCubeClientDetails(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithComplyCubeClientDetails {
        data {
          client {
            _id
            id
            entityName
            type
            email
            personDetails {
              firstName
              lastName
              dob
              nationality
            }
            createdAt
            updatedAt
          }
          documents {
            _id
            id
            clientId
            type
            issuingCountry
            classification
            images {
              id
              documentSide
              fileName
              downloadLink
              contentType
              size
              clientId
              s3
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
            user {
              id
              firstName
              lastName
              email
            }
          }
          addresses {
            _id
            id
            clientId
            line
            city
            postalCode
            state
            country
            createdAt
            updatedAt
            user {
              id
              firstName
              lastName
              email
            }
          }
          livePhotos {
            _id
            id
            clientId
            downloadLink
            contentType
            performLivenessCheck
            metadata
            size
            s3
            createdAt
            updatedAt
            user {
              id
              firstName
              lastName
              email
            }
          }
        }
      }
    }
  }
`;

export const GET_COMPLY_CUBE_CHECKS = gql`
  query GetComplyCubeChecks($input: GetComplyCubeChecksInput) {
    getComplyCubeChecks(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithComplyCubeChecks {
        data {
          _id
          id
          entityName
          type
          clientId
          livePhotoId
          documentId
          status
          result {
            outcome
          }
          createdAt
          updatedAt
          user {
            id
            firstName
            lastName
            email
          }
        }
        pagination {
          total
        }
      }
    }
  }
`;

export const GET_COMPLY_CUBE_DOCUMENTS = gql`
  query GetComplyCubeDocuments($input: GetComplyCubeDocumentsInput) {
    getComplyCubeDocuments(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithComplyCubeDocuments {
        data {
          _id
          id
          clientId
          type
          issuingCountry
          classification
          user {
            id
            firstName
            lastName
            email
          }
          images {
            id
            documentSide
            fileName
            downloadLink
            contentType
            size
            clientId
            s3
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        pagination {
          total
        }
      }
    }
  }
`;

export const GET_COMPLY_CUBE_ADDRESSES = gql`
  query GetComplyCubeAddresses($input: GetComplyCubeAddressesInput) {
    getComplyCubeAddresses(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithComplyCubeAddresses {
        data {
          _id
          id
          clientId
          line
          city
          postalCode
          state
          country
          createdAt
          updatedAt
          user {
            id
            firstName
            lastName
            email
          }
        }
        pagination {
          total
        }
      }
    }
  }
`;

export const GET_COMPLY_CUBE_LIVE_PHOTOS = gql`
  query GetComplyCubeLivePhotos($input: GetComplyCubeLivePhotosInput) {
    getComplyCubeLivePhotos(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithComplyCubeLivePhotos {
        pagination {
          total
        }
        data {
          _id
          id
          clientId
          downloadLink
          contentType
          performLivenessCheck
          metadata
          size
          s3
          createdAt
          updatedAt
          user {
            id
            firstName
            lastName
            email
          }
        }
      }
    }
  }
`;
